import { WCConnector } from "./WCConnector";
import { HederaNetwork } from "./models/blade";
import { LedgerId } from "@hashgraph/sdk";
import { getBladeExtension } from "./helpers/interfaceHelpers";
import { getAccountIDsFromSigners } from "./helpers/utils";
export class ExtensionConnector extends WCConnector {
    constructor(meta) {
        super(meta);
    }
    async createSession(params) {
        const extension = await getBladeExtension();
        if (extension) {
            const networkName = ((params === null || params === void 0 ? void 0 : params.network) || HederaNetwork.Mainnet).toLowerCase();
            const data = await this.dAppConnector.prepareConnectURI(LedgerId.fromString(networkName));
            if (data) {
                await extension.pairWC(data.uri);
                const session = await data.approval();
                await this.onSessionChange(session);
                return getAccountIDsFromSigners(this.signers);
            }
            else {
                const existingSession = await this.dAppConnector.checkPersistedState();
                if (existingSession) {
                    await this.onSessionChange(existingSession);
                    return getAccountIDsFromSigners(this.signers);
                }
                return [];
            }
        }
        return [];
    }
    async onSessionChange(session) {
        await this.dAppConnector.onSessionConnected(session);
        this.signers = this.dAppConnector.getSigners();
        this.activeSigner = this.signers[0] || null;
        await this.selectAccount();
    }
}
